/// <amd-module name="Repos/Views/PullRequest/Markdown/Checkbox" />
import * as React from "react";
import { IMarkdownRendererTransformer, IMarkdownTransformContext } from "VSS/Features/Markdown/MarkdownRendererContracts";
import { css } from "VSS/Platform/Layout";
import { Checkbox } from "VSSUI/Checkbox";

const checkboxRegEx = new RegExp("^\\s*(-|\\*|(\\d+\\.))\\s+\\[( |x|X)\\]", "gm"); // (start of line)(optional whitespace)(- or * or 1.)(required whitespace)([ ] or [x])

export function getCheckboxMarkdownTransformer(onChange: (newMarkup: string) => void, canChangeMarkup?: () => boolean): IMarkdownRendererTransformer {
    return (context: IMarkdownTransformContext): void => {
        context.markup = context.markup.replace(
            checkboxRegEx,
            (fullMatch: string, prefix: string, listNumber: string, checkContent: string, offset: number) => {
                const checked = !!checkContent && checkContent.toLowerCase().indexOf("x") >= 0;
                const newPrefix = listNumber ? prefix + " " : "";
                return (
                    newPrefix +
                    context.createReplacement(
                        <Checkbox
                            checked={checked}
                            className="pr-markdown-checkbox"
                            disabled={canChangeMarkup ? !canChangeMarkup() : true}
                            onChange={() => {
                                const newCheckValue = checked ? " " : "X";
                                const newMarkup =
                                    context.originalMarkup.substr(0, offset) +
                                    fullMatch.replace(`[${checkContent}]`, `[${newCheckValue}]`) +
                                    context.originalMarkup.substr(offset + fullMatch.length);
                                onChange(newMarkup);
                            }}
                        />,
                        "span",
                        css("pr-markdown-checkbox-container", !listNumber && "non-numbered-list")
                    )
                );
            }
        );
    };
}
